import { useProcessGroupsWithMidgardData } from "components/Dashboard/Tiles/GroupTile/GroupTilesPanel";
import { useSelector } from "store/useSelector";
import { getPgKey } from "utils/customHooks/genericHooks";
import { DataDumpGetterForOneGroupTile } from "./DataDumpGetterForOneGroupTile";
import { isEqual } from "lodash";

export function DataDumpGettersForGroupTiles() {
  const processGroups = useProcessGroupsWithMidgardData();
  const allConstraintProcessIds = useSelector(
    state => state.legacy.constraintProcessIds,
    isEqual
  );

  return (
    <>
      {processGroups.map(({ shortName, processes, summaryGroup }) => {
        const pgKey = getPgKey(shortName);
        const constraintProcessIds = allConstraintProcessIds[pgKey] ?? [];
        const processesFiltered =
          constraintProcessIds.length === 0
            ? processes
            : processes.filter(p => constraintProcessIds.includes(p.id));
        return (
          <DataDumpGetterForOneGroupTile
            key={shortName}
            {...{ shortName, processes: processesFiltered, summaryGroup }}
          />
        );
      })}
    </>
  );
}
